/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-underscore-dangle */
import React, { useState } from 'react';

import { Button, Card, Layout, PageHeader, Progress, Tooltip, Typography } from 'antd';
import dayjs from 'dayjs';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

import GTooltip from '../../../components/GTooltip/GTooltip';
import XDataForm, { XDF_TYPE } from '../../../components/xdf-antd/XDataForm';
import styles from './styles.scss';
import apiMapAnalytics from '../../../../api/MapAnalytics';
import KybMapAnalyticsByKey from './KybMapAnalyticsByKey';
import KybMapAnalyticsTop20PI from './KybMapAnalyticsTop20PI';
import { roundPlus } from '../../../utils/utils';

const MAX_ROWS = 40;

const tbls = [
  {
    pageTitle: 'Аналитическая выкладка "Устройства"',
    byKey: 'byDev',
    title: 'Устройства',
    tableTitle: 'Тип устройства',
  },
  {
    pageTitle: 'Аналитическая выкладка "Браузеры"',
    byKey: 'byBrowser',
    title: 'Браузеры',
    tableTitle: 'Браузер',
  },
  {
    pageTitle: 'Аналитическая выкладка "МЕСТОПОЛОЖЕНИЕ"',
    byKey: 'byCountry',
    title: 'Страны',
    tableTitle: 'Страна',
  },
  {
    pageTitle: 'Аналитическая выкладка "МЕСТОПОЛОЖЕНИЕ"',
    byKey: 'byRussiaRegions',
    title: 'Регионы России',
    tableTitle: 'Регион',
  },
  // {
  //   byKey: 'top20PoiInfo',
  // },
];

export default function MapAnalytics() {
  const [stats, setStats] = useState(null);
  const [regions, setRegions] = useState([]);

  const [loading, setLoading] = useState(false);
  const [renderPercent, setRenderPercent] = useState(-1);

  const [model, setModel] = useState({
    startDt: dayjs().date(1).format('DD.MM.YYYY'),
    endDt: dayjs().format('DD.MM.YYYY'),
  });

  const onChangeModel = (m) => {
    setModel({ ...m });
  };

  const onLoadData = async () => {
    setLoading(true);
    const data = await apiMapAnalytics(model.startDt, model.endDt);
    setLoading(false);
    setStats(data);
    setRegions(Object.keys(data.topPoiInfoByRegions));
  };

  const renderPart = (partNumber) => {
    if (partNumber === 0) {
      return (
        <div key="part0" className={styles.contextPadding}>
          <Card title={`Аналитическая выкладка "Устройства и Браузеры"`}>
            <Typography.Title
              level={5}
            >{`Общее количество сеансов за период - ${stats.common._cnt}`}</Typography.Title>

            <KybMapAnalyticsByKey
              stats={stats}
              byKey="byDev"
              title="Устройства"
              tableTitle="Тип устройства"
            />
            <KybMapAnalyticsByKey
              stats={stats}
              byKey="byBrowser"
              title="Браузеры"
              tableTitle="Браузер"
            />
          </Card>
        </div>
      );
    }

    if (partNumber === 1) {
      return (
        <div key="part1" className={styles.contextPadding}>
          <Card title={'Аналитическая выкладка "МЕСТОПОЛОЖЕНИЕ"'}>
            <KybMapAnalyticsByKey
              stats={stats}
              byKey="byCountry"
              title="Страны"
              tableTitle="Страна"
            />
            <KybMapAnalyticsByKey
              stats={stats}
              byKey="byRussiaRegions"
              title="Регионы России"
              tableTitle="Регион"
            />
          </Card>
        </div>
      );
    }

    if (partNumber === 2) {
      return (
        <div key="part2" className={styles.contextPadding}>
          <Card title={`Аналитическая выкладка "ПРОСМОТРЫ"`}>
            <Typography.Title
              level={5}
            >{`Общее количество сеансов за период - ${stats.common._cnt}`}</Typography.Title>
            <Typography.Title level={4}>"ТОП 20" POI по просмотру карточек</Typography.Title>
            <KybMapAnalyticsTop20PI stats={stats} />
          </Card>
        </div>
      );
    }

    if (partNumber === 3) {
      return regions.map((r, i) => (
        <div key={`part-r-${i}`} className={styles.contextPadding}>
          <Card key={r} title={'Аналитическая выкладка "ПРОСМОТРЫ"'}>
            <Typography.Title
              level={4}
            >{`"ТОП 10" POI по просмотру карточек в "${r}"`}</Typography.Title>
            <KybMapAnalyticsTop20PI stats={stats} statKey={`topPoiInfoByRegions.${r}`} />
          </Card>
        </div>
      ));
    }

    return null;
  };

  const generatePdfSection = async () => {
    setRenderPercent(0);

    // eslint-disable-next-line new-cap
    const pdf = new jsPDF('p', 'pt', 'a4');
    const pdfInternals = pdf.internal;
    const pdfPageSize = pdfInternals.pageSize;
    const pdfPageWidth = pdfPageSize.width;

    let page = 0;
    const maxPages = regions.length + 5;
    async function tick() {
      const el = document.querySelector(`#map-analytics-${page}`);

      if (el) {
        // eslint-disable-next-line no-await-in-loop
        const canvas = await html2canvas(el, {
          backgroundColor: '#ffffff',
          allowTaint: true,
          logging: true,
        });

        pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 10, 10, pdfPageWidth - 10, 0);
        pdf.addPage();

        page += 1;
        setRenderPercent((page * 100) / maxPages);
        setTimeout(tick, 50);
      } else {
        pdf.save('MapAnalytics.pdf');
        setRenderPercent(-1);
      }
    }

    setTimeout(tick, 100);
  };

  const renderPeriod = () => dayjs(model.startDt, 'DD.MM.YYYY').format('MMMM YYYY');

  const renderPdfPage = (section, sectionPart) => (
    <Card
      id={`map-analytics-${section}`}
      key={`pdf-gen-${section}`}
      title={
        <img
          className={styles.kybLogo}
          src="data:image/svg+xml;base64,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"
          style={{ width: 144 }}
          alt="LOGO"
        />
      }
    >
      {section <= 3 && (
        <KybMapAnalyticsByKey
          stats={stats}
          startItem={MAX_ROWS * sectionPart}
          maxItems={MAX_ROWS}
          {...tbls[section]}
          period={`Период - ${renderPeriod()}`}
        />
      )}

      {section === 4 && (
        <>
          <div className="md-subheading-2">{`Период - ${renderPeriod()}`}</div>
          <div className="md-headline">Аналитическая выкладка &quot;ПРОСМОТРЫ&quot;</div>
          <div className="md-subheading-2">{`Общее количество сеансов за период - ${stats.common._cnt}`}</div>
          <div className="md-headline">&quot;ТОП 20&quot; POI по просмотру карточек</div>
          <KybMapAnalyticsTop20PI stats={stats} />
        </>
      )}

      {section >= 5 && (
        <>
          <div className="md-subheading-2">{`Период - ${renderPeriod()}`}</div>
          <div className="md-headline">Аналитическая выкладка &quot;ПРОСМОТРЫ&quot;</div>
          <div className="md-subheading-2">{`"ТОП 10" POI по просмотру карточек в "${
            regions[section - 5]
          }"`}</div>
          <KybMapAnalyticsTop20PI
            stats={stats}
            statKey={`topPoiInfoByRegions.${regions[section - 5]}`}
          />
        </>
      )}
    </Card>
  );

  return (
    <>
      <div style={{ position: 'relative' }}>
        <PageHeader
          key="header"
          className={styles.pageHeader}
          title={<GTooltip tid="map_analytics">Аналитика карты</GTooltip>}
          subTitle={
            <XDataForm
              inline
              key="data-range"
              model={model}
              onChangeModel={onChangeModel}
              form={[
                {
                  type: XDF_TYPE.DATERANGE,
                  prop: 'startDt',
                  prop2: 'endDt',
                  span: 24,
                  readOnly: loading || renderPercent > 0,
                },
              ]}
            />
          }
          extra={[
            <Tooltip key="download" title="Загрузить аналитику за даты">
              <Button onClick={onLoadData} disabled={loading || renderPercent > 0}>
                Загрузить
              </Button>
            </Tooltip>,
            <Tooltip key="pdf" title="Создать PDF файл">
              <Button
                onClick={generatePdfSection}
                disabled={!(stats && stats.common) || renderPercent > 0}
              >
                PDF
              </Button>
            </Tooltip>,
          ]}
        />
        {loading && <div className={styles['progress-line']} />}
        {renderPercent >= 0 && (
          <div className={styles.pdfProgress}>
            <Progress
              percent={renderPercent}
              size="small"
              format={(percent) => `${roundPlus(percent, 0)}%`}
            />
          </div>
        )}
      </div>

      <Layout.Content key="main-context">
        {stats && stats.common && (
          <>
            {renderPart(0)}
            {renderPart(1)}
            {renderPart(2)}
            {renderPart(3)}
          </>
        )}
      </Layout.Content>

      {stats && stats.common && (
        <div key="pdf-gen" className={styles.pdfPages}>
          {tbls.map((x, i) => renderPdfPage(i, 0))}
          {renderPdfPage(4, 0)}
          {regions.map((r, i) => renderPdfPage(i + 5, 0))}
        </div>
      )}
    </>
  );
}
